if (document.querySelector('body [data-braze-form]')) {
    // console.log("Inside if condition of braze-form js file");
    let form = document.getElementById("brazeFormSignUp");
    let allRadios = form.querySelectorAll('[data-campaign]');

    var formsBrazeCookieArray = [];
    if(Utility.getCookie('BUID_Cookie') != '' && Utility.getCookie('BUID_Cookie') != null && Utility.getCookie('BUID_Cookie') != 'BUID_Cookie') {
      if(Utility.getCookie('BUID_Cookie').indexOf(',') >= 0){
        formsBrazeCookieArray = Utility.getCookie('BUID_Cookie').split(',');
      }
      else if(Utility.getCookie('BUID_Cookie').indexOf('[') < 0){
        formsBrazeCookieArray.push(Utility.getCookie('BUID_Cookie'));  
      }
      else{
        formsBrazeCookieArray = JSON.parse(Utility.getCookie('BUID_Cookie'));
      }
    }

    form.onsubmit = function (e) {
      e.preventDefault();
      let externalIDSelector = form.querySelector(`[data-externalID]`);
      let allCheckedBoxs = form.querySelectorAll('[data-campaign]:checked');
      let allCheckedBoxValues = new Array();
      allCheckedBoxs.forEach((allCheckedBox) => {allCheckedBoxValues.push(allCheckedBox.value)});
      let allergyTypeField = form.querySelector('[name="allergy_type"]');
      allergyTypeField.value = allCheckedBoxValues.toString();
      const xhttp = new XMLHttpRequest();
      xhttp.onload = function () {
        if(xhttp.status == 200) {
          if(formsBrazeCookieArray.includes(JSON.parse(this.responseText).external_id)){
            form.nextElementSibling.innerHTML = '<div class="mt-3 mt-md-4 px-1 px-md-2" style="color: #202d51;">Je hebt je al aangemeld</div>';
          }
          else {
            form.nextElementSibling.innerHTML = '<div class="mt-3 mt-md-4 px-1 px-md-2" style="color: #202d51;">Bedankt voor het aanmelden</div>';
            formsBrazeCookieArray.push(JSON.parse(this.responseText).external_id);  
            var formsBrazeCookieJsonStr = formsBrazeCookieArray + '';
            Utility.setCookie('BUID_Cookie', formsBrazeCookieJsonStr, 90);
          }
          form.querySelector('button').classList.add("d-none");
          if (typeof braze !== 'undefined' ) {
            //braze sdk is loaded and we can tun the changeUser function
            braze.changeUser(this.responseText);
          }
          if(typeof appboy !== 'undefined'){
            //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
            appboy.changeUser(this.responseText);
          }
        }
        else {
          console.log("Error")
          form.nextElementSibling.innerHTML = '<div class="mt-3 mt-md-4 font-size-sm px-1 px-md-2" style="color: #202d51;">Het spijt me, er is iets misgegaan</div>';
        }
      };
      xhttp.open("POST", "https://datahub.klarify.me/api/webhook/create_braze_profile");
      const serializer = new XMLSerializer();
      xhttp.send(new FormData(form));
      let nameSIgnup = document.querySelector('#brazeFormSignUp input[name="first_name"]').value;
      let emailSIgnup = document.querySelector('#brazeFormSignUp input[name="email"]').value;
      window.dataLayer.push({
          'event': 'Newsletter_Signup',
          'name': `${nameSIgnup}`,
          'mail': `${emailSIgnup}`,
          'topics_selected': `${allCheckedBoxValues}`
      }); 
    };
  }